/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { SendNotificationEmailRequest } from '../../models/send-notification-email-request';

export interface SendTourWalletInviteMailToDriver$Params {
  organizationSiteKey: KeyType;
  tourKey: KeyType;
      body: SendNotificationEmailRequest
}

export function sendTourWalletInviteMailToDriver(http: HttpClient, rootUrl: string, params: SendTourWalletInviteMailToDriver$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, sendTourWalletInviteMailToDriver.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('tourKey', params.tourKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

sendTourWalletInviteMailToDriver.PATH = '/organization-sites/{organizationSiteKey}/tours/{tourKey}/send-wallet-invite';
